export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fd19c8bbd0de7c991cf364a65f8890cdd24c11b3d&name=fetchTypeahead!'